import * as Sentry from '@sentry/react';

export function initSentry(dsn: string, env: string, release: string) {
  Sentry.init({
    dsn,
    environment: env,
    release,
    // Replay may only be enabled for the client-side
    // integrations: [new Sentry.Replay()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: env === 'dev' ? 1.0 : 0.5,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
